import { cn } from '@/lib/utils'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { Question } from '@phosphor-icons/react'
import type { Metric } from '../../types'

interface MetricRowProps {
  metric: Metric
}

export function MetricRow({ metric }: MetricRowProps) {
  return (
    <div className="flex items-center justify-between py-2.5 border-b border-border/50 last:border-0">
      <div className="flex items-center gap-2 min-w-0">
        <span
          className={cn(
            'flex-shrink-0 w-1.5 h-1.5 rounded-full',
            metric.status === 'success' && 'bg-success',
            metric.status === 'warning' && 'bg-warning',
            metric.status === 'danger' && 'bg-destructive',
            (metric.status === 'accent' || !metric.status) && 'bg-muted-foreground/40',
          )}
        />
        <span className="text-xs text-muted-foreground truncate">{metric.label}</span>
        {metric.description && (
          <Tooltip>
            <TooltipTrigger asChild>
              <Question weight="regular" className="flex-shrink-0 w-3 h-3 text-muted-foreground/40 cursor-help" />
            </TooltipTrigger>
            <TooltipContent className="bg-card border-border text-xs max-w-[220px] leading-relaxed">
              {metric.description}
            </TooltipContent>
          </Tooltip>
        )}
      </div>
      <span
        className={cn(
          'text-sm font-semibold tabular-nums font-mono flex-shrink-0 ml-3',
          metric.status === 'success' && 'text-success',
          metric.status === 'warning' && 'text-warning',
          metric.status === 'danger' && 'text-destructive',
          (metric.status === 'accent' || !metric.status) && 'text-foreground',
        )}
      >
        {metric.formattedValue}
      </span>
    </div>
  )
}
